export const formatCurrency = (value: string | number): string => {
  const floatValue = typeof value === 'string' ? parseFloat(value) : value;
  return floatValue.toFixed(2).replace('.', ',');
};
